import React, {useState,useRef,useEffect} from 'react'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {useAuth} from "../other/auth"
import Popup from "./Popup/Popup"
import Cookies from 'js-cookie'

const Container = styled.div`
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background: radial-gradient(circle, rgba(20,30,48,1) 0%, rgba(10,10,10,1) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow:hidden;
`

const Box = styled.form`
    width: 90%;
    max-width: 450px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 24px;
    padding: 40px;
    box-shadow: 0 30px 60px rgba(0,0,0,0.6);
    color: white;
    text-align: center;
    animation: fadeIn 0.8s ease-out;

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }

    & > h2 { font-size: 1.8rem; margin-bottom: 5px; color: #fff; font-weight: 900; }
    & > h5 { font-size: 0.9rem; color: rgba(255,255,255,0.5); margin-bottom: 35px; font-weight: normal; }
    & > label { display: block; text-align: left; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 2px; color: rgba(255,255,255,0.7); margin-bottom: 8px; font-weight: 800; }
`

const Logo = styled.img`
    width: 180px;
    margin-bottom: 25px;
`

const Input = styled.input`
    background: rgba(0,0,0,0.3) !important;
    border: 2px solid rgba(255,255,255,0.1) !important;
    color: white !important;
    padding: 15px !important;
    border-radius: 12px !important;
    margin-bottom: 25px !important;
    font-size: 1rem !important;
    width: 100% !important;

    &:focus {
        border-color: #00d2ff !important;
        background: rgba(0,0,0,0.5) !important;
        outline: none;
    }
`

const Button = styled.button`
    width: 100%;
    background: linear-gradient(90deg, #00d2ff 0%, #3a7bd5 100%) !important;
    border: none !important;
    color: white !important;
    font-weight: 900 !important;
    padding: 18px !important;
    border-radius: 14px !important;
    text-transform: uppercase;
    letter-spacing: 2px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    margin-top: 15px;
    box-shadow: 0 10px 25px rgba(0, 210, 255, 0.3);

    &:hover, &:focus {
        transform: scale(1.03);
        box-shadow: 0 15px 35px rgba(0, 210, 255, 0.5);
    }
    
    &:active {
        transform: scale(0.98);
    }
`

const Login = ({url}) => {
    const [dns, setDns] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const history = useHistory();
    const auth = useAuth();

    useEffect(() => {
        if(auth.isAuth())
            history.push(url||"/")
        else auth.authLogin(()=>history.push(url||"/"))
    },[auth,history,url]);
    
    const inputRef = useRef(0)

    const login = (e) =>{
        e.preventDefault();
        if(!username || !password) return;
        setIsLoggingIn(true)
        auth.signin(dns ,username,password, 
            () => window.location="/"
            ,
            (title,description) => {
                setIsLoggingIn(false)
                setShowPopup({title: "Erro de Login", description: "Usuário ou senha incorretos. Verifique suas credenciais."});
            }
        )
    }

    const closePopup = () =>{
        setShowPopup(false);
    }

    return (
        <>
        <Container>
            <Box onSubmit={login} style={isLoggingIn ? {opacity: 0.7, pointerEvents: 'none'} : {}}>
                <Logo src="/img/logo_pro.png" alt="TopTV Pro" />
                <h2>TopTV PRO</h2>
                <h5>Sua melhor experiência de entretenimento</h5>
                
                <label>Usuário</label>
                <Input ref={inputRef} className="form-control" type="text" spellCheck={false} placeholder="Digite seu usuário" name="username" autoFocus onChange={(e)=> setUsername(e.target.value)} value={username} />
                
                <label>Senha</label>
                <Input className="form-control" type="password" spellCheck={false} placeholder="Digite sua senha" name="password" onChange={(e)=> setPassword(e.target.value)} value={password}/>
                
                <Button type="submit" className="btn">
                    {isLoggingIn ? 'Autenticando...' : 'Entrar na conta'}
                </Button>
            </Box>
        </Container>
        {showPopup && <Popup unsecure={true} title={showPopup.title} description={showPopup.description} icon={"fas fa-user-times"}  onclick={closePopup}/>}
        </>
    )
}

export default Login
